// PROD-DEMO-LOCKDOWN-1 (Feb 2026) — Runtime config snapshot hook.
//
// Pulls the unauthenticated /_meta/runtime-config snapshot once and
// memoises it for the session. All flags default to "safe" (everything
// off / public open) until the snapshot lands, so Preview keeps working
// unchanged when this hook is added to a page.
//
// NOT PRODUCTION · NOT CUSTOMER-FACING — admin-only QA review surface.

import { useEffect, useState } from "react";

const DEFAULT_CONFIG = {
  public_registration_enabled: true,
  login_allowlist_enabled: false,
  public_flows_blocked: false,
  demo_lockdown_banner_enabled: false,
  // PREVIEW-SIGNUP-APP-SELECTION-CHOICE-1 (Feb 2026) — per-app
  // registration gate snapshot. Safe defaults assume only the
  // Questionnaires gate is open, matching the Preview/Prod env state.
  app_gates: {
    questionnaires: true,
    racket_lab: false,
    marketplace: false,
    nutrition: false,
    physiotherapy: false,
    sponsors: false,
  },
  __loaded: false,
};

export function useRuntimeConfig() {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  useEffect(() => {
    let cancelled = false;
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;
    fetch(`${base}/api/_meta/runtime-config`, { credentials: "omit" })
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        if (cancelled || !json) return;
        setConfig({ ...DEFAULT_CONFIG, ...json, __loaded: true });
      })
      .catch(() => {
        // Network blip — fall back to safe defaults; component still renders.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}
